import { Spin } from "antd";
import * as qs from "querystring";
import * as React from "react";
import { Redirect } from "react-router-dom";

import * as httpClient from "utils/httpClient";
import "./style.css";

interface IProps {
  route: any;
}

export default class extends React.Component<IProps, object> {
  public state = {
    user: null
  };

  public async componentWillMount() {
    const { token } = qs.parse(this.props.route.location.search.replace("?", ""));
    sessionStorage.setItem("token", token.toString());
    const user = await httpClient.get("/v1/account/auth");
    sessionStorage.setItem("user", JSON.stringify(user));
    this.setState({ user });
  }

  public render() {
    const { redirect } = qs.parse(this.props.route.location.search.replace("?", ""));

    return this.state.user ?
      <Redirect to={{ pathname: redirect.toString() }} /> :
      <div className="mts-loading-user-info"><Spin /></div>;
  }
}